import React from "react";
import { Link } from "react-router-dom";

export default function NoPage() {
    return (
        <main className="min-h-screen bg-slate-950 text-white flex items-center justify-center px-6 relative overflow-hidden">
            {/* Ambient glow */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-amber-500/5 blur-[120px] rounded-full pointer-events-none" />

            <div className="text-center relative z-10">
                <div className="mb-8">
                    <span className="text-[8rem] md:text-[10rem] font-black leading-none text-transparent bg-clip-text bg-gradient-to-b from-amber-500 to-amber-500 select-none">
                        404
                    </span>
                </div>

                <div className="w-16 h-16 mx-auto rounded-2xl bg-amber-500/10 border border-amber-500/20 flex items-center justify-center text-amber-400 text-3xl mb-6">
                    <i className="bi bi-compass" aria-hidden="true" />
                </div>

                <h1 className="text-3xl md:text-4xl font-bold text-white mb-3 font-heading">
                    Page Not Found
                </h1>

                <p className="text-slate-400 max-w-md mx-auto mb-8 leading-relaxed">
                    The page you're looking for doesn't exist or has been moved.
                    Let's get you back on track.
                </p>

                <Link
                    to="/"
                    className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-amber-500 text-slate-950 font-bold hover:bg-amber-400 hover:shadow-lg hover:shadow-amber-500/20 hover:-translate-y-0.5 transition-all duration-300"
                >
                    <i className="bi bi-arrow-left" aria-hidden="true" />
                    Back to Home
                </Link>
            </div>
        </main>
    );
}